<template>
  <div class="settings">
    <h3>来电接听</h3>
    <div class="item">
      <span class="label">分配方式</span>
      <el-select v-model="formData.fixme1" placeholder="请选择 分配方式">
        <el-option
          v-for="(item, index) in fixme1DictData"
          :key="index"
          :label="item.dictValue"
          :value="item.dictKey"
        ></el-option>
      </el-select>
    </div>
    <div>
      非群振方式时，振铃
      <el-input class="small-width" v-model="formData.fixme9" maxlength="3"></el-input>
      秒后转下一个分机
    </div>
    <h3>电话转接</h3>
    <div class="item">
      <span class="label">展示策略</span>
      <el-select v-model="formData.fixme2" placeholder="请选择">
        <el-option
          v-for="(item, index) in fixme2DictData"
          :key="index"
          :label="item.dictValue"
          :value="item.dictKey"
        ></el-option>
      </el-select>
    </div>
    <div class="item">
      <span class="label">转外策略</span>
      <el-select v-model="formData.fixme3" placeholder="请选择">
        <el-option
          v-for="(item, index) in fixme3DictData"
          :key="index"
          :label="item.dictValue"
          :value="item.dictKey"
        ></el-option>
      </el-select>
    </div>
    <h3>虚拟坐席</h3>
    <div class="item item-time">
      <span class="label">时段定义</span>
      <div>
        <el-radio-group v-model="formData.fixme7">
          <el-radio :label="1">自定义</el-radio>
          <el-radio :label="2">全工作</el-radio>
          <el-radio :label="3">全休息</el-radio>
        </el-radio-group>
        <div class="mt10" v-if="formData.fixme7 == 1">
          <span>工作时段</span>
          <el-select class="small-width" placeholder="" v-model="formData.fixme8">
            <el-option
              v-for="(item, index) in weekList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          至
          <el-select class="small-width" placeholder="" v-model="formData.fixme9">
            <el-option
              v-for="(item, index) in weekList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <div class="mt10" v-for="(t, index) in weekTimes" :key="index">
            起止时间
            <el-time-picker
              is-range
              v-model="weekTimes[index]"
              range-separator="至"
              value-format="HH:mm"
            >
            </el-time-picker>
            <i v-if="index == 0" class="el-icon-circle-plus-outline icon" @click="addWorkTime"></i>
            <i v-else class="el-icon-delete icon" @click="delWorkTime(index)"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="item">
      <span class="long-label">工作时段语音导航</span>
      <el-select v-model="formData.fixme4" placeholder="请选择">
        <el-option
          v-for="(item, index) in navVoiceList"
          :key="index"
          :label="item.dictValue"
          :value="index"
        ></el-option>
      </el-select>
      <i class="el-icon-headset icon" @click="doTrial('fixme4')"></i>
    </div>
    <div class="item">
      <span class="long-label">非工作时段语音导航</span>
      <el-select v-model="formData.fixme5" placeholder="请选择">
        <el-option
          v-for="(item, index) in navVoiceList"
          :key="index"
          :label="item.dictValue"
          :value="index"
        ></el-option>
      </el-select>
      <i class="el-icon-headset icon" @click="doTrial('fixme5')"></i>
    </div>
    <h3>彩铃设置</h3>
    <div class="item">
      <span class="label">彩铃</span>
      <el-select v-model="formData.fixme6" placeholder="请选择">
        <el-option
          v-for="(item, index) in ringList"
          :key="index"
          :label="item.dictValue"
          :value="index"
        ></el-option>
      </el-select>
      <i class="el-icon-headset icon" @click="doTrial('fixme6')"></i>
    </div>
    <el-button size="small" type="primary" @click="doSave()"> 保存 </el-button>
  </div>
</template>

<script>
import { getDictApi } from '@/api/call-system/index';
import { getAudioListApi, saveRuleApi } from '@/api/call-system/call-manage/rule-config';

export default {
  data() {
    return {
      formData: {},
      fixme1DictData: [],
      fixme2DictData: [],
      fixme3DictData: [],
      navVoiceList: [], // 语音导航列表
      ringList: [], // 彩铃列表
      weekList: [
        { value: 0, label: '星期日' },
        { value: 1, label: '星期一' },
        { value: 2, label: '星期二' },
        { value: 3, label: '星期三' },
        { value: 4, label: '星期四' },
        { value: 5, label: '星期五' },
        { value: 6, label: '星期六' },
      ],
      weekTimes: [undefined], // 至少保留一个占位项，否则组件不会渲染出来
    };
  },
  created() {
    this.fixme1DictData = [
      { dictKey: 1, dictValue: '轮选' },
      { dictKey: 2, dictValue: '顺选' },
      { dictKey: 3, dictValue: '群振' },
      { dictKey: 4, dictValue: '业务优先' },
    ];
    this.fixme2DictData = [
      { dictKey: 1, dictValue: '全量展示' },
      { dictKey: 2, dictValue: '过滤离线' },
      { dictKey: 3, dictValue: '过滤非空闲' },
    ];
    this.fixme3DictData = [
      { dictKey: 1, dictValue: '不转外' },
      { dictKey: 2, dictValue: '响铃3次后转外线' },
      { dictKey: 3, dictValue: '响铃5次后转外线' },
    ];
    this.navVoiceList = [
      { dictKey: 1, dictValue: 'welcome' },
      { dictKey: 2, dictValue: 'offhour' },
    ];
    this.ringList = [
      { dictKey: 1, dictValue: 'ring' },
      { dictKey: 2, dictValue: 'ring2' },
    ];
    /* getDictApi({
      code: 'fixme',
    }).then(({ data }) => {
      this.fixme1DictData = data;
    });
    getDictApi({
      code: 'fixme',
    }).then(({ data }) => {
      this.fixme2DictData = data;
    });
    getDictApi({
      code: 'fixme',
    }).then(({ data }) => {
      this.fixme3DictData = data;
    }); 
    this.getAudioList();
    */
  },
  methods: {
    /* 获取音频文件列表 */
    getAudioList() {
      getAudioListApi({
        type: 1,
      }).then(({ data }) => {
        this.ringList = data;
      });
      getAudioListApi({
        type: 2,
      }).then(({ data }) => {
        this.navVoiceList = data;
      });
    },
    /* 试听->实际是下载 */
    doTrial(type) {
      let audioObj = null;
      if (type == 'fixme4') {
        audioObj = this.navVoiceList[this.formData.fixme4];
      } else if (type == 'fixme5') {
        audioObj = this.navVoiceList[this.formData.fixme5];
      } else {
        audioObj = this.ringList[this.formData.fixme6];
      }
      window.open(audioObj.audioUrl);
    },
    /* 增加自定义工作时间段 */
    addWorkTime() {
      this.weekTimes.push(undefined);
    },
    /* 删除自定义工作时间段 */
    delWorkTime(index) {
      this.weekTimes.splice(index, 1);
    },
    /* 保存 */
    doSave() {
      saveRuleApi(this.formData).then(() => {
        this.$message.success('操作成功!');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  .label {
    width: 80px;
  }
  .long-label {
    width: 160px;
  }
}

.item-time {
  align-items: flex-start;
}

.icon {
  margin-left: 10px;
  cursor: pointer;
}

.mt10 {
  margin-top: 10px;
}
.small-width {
  width: 90px !important;
  margin: 0 10px;
}
</style>
